import React, { useState } from "react";

import t from "../../../Common/utils/translation/translator";

import AxisSelectionTableCollapsableHeadersSection from "./AxisSelectionTableCollapsableHeadersSection";
import AxisSelectionTableHeadersSection from "./AxisSelectionTableHeadersSection";
import AxisSelectionTableRowsSection from "./AxisSelectionTableRowsSection";

import TableSkeleton from "../../../Common/components/TableSkeleton/TableSkeleton";
import Pagination from "../../../Common/components/Pagination/Pagination";

const AxisSelectionTableSection = ({
  axesCombinations,
  isLoadingOrFetching,
  countOfResults,
  paging,
  setPaging,
  mechanics,
  selectedAxis,
  axesToCompare,
  axisSelection,
  steps,
  productTableHeaders,
  technicalFeaturesTableHeaders,
  performanceOverviewTableHeaders,
  getGuidingSystemTableHeaders,
  setCartesianCurrentStep,
  setAxisOptions,
  setAxisSelection,
  addAxisToCompare,
  ...props
}) => {
  const [productLength, setProductLength] = useState(productTableHeaders.length);
  const [productExpand, setProductExpand] = useState(true);
  const [technicalFeatureLength, setTechnicalFeatureLength] = useState(1);
  const [technicalFeatureExpand, setTechnicalFeatureExpand] = useState(false);
  const [performanceOverviewLength, setPerformanceOverviewLength] = useState(performanceOverviewTableHeaders.length);
  const [performanceOverviewExpand, setPerformanceOverviewExpand] = useState(true);
  const [guidingSystemLength, setGuidingSystemLength] = useState(mechanics.quantityCarriages);
  const [guidingSystemExpand, setGuidingSystemExpand] = useState(true);

  return (
    <>
      <table cellSpacing={0} className="AxisSelectionTableSection border-separate min-w-full mb-2" {...props}>
        <thead>
          <AxisSelectionTableCollapsableHeadersSection
            data-testid="axis-selection-table-collapsable-headers-section"
            productLength={productLength}
            setProductLength={setProductLength}
            productExpand={productExpand}
            setProductExpand={setProductExpand}
            technicalFeatureLength={technicalFeatureLength}
            setTechnicalFeatureLength={setTechnicalFeatureLength}
            technicalFeatureExpand={technicalFeatureExpand}
            setTechnicalFeatureExpand={setTechnicalFeatureExpand}
            performanceOverviewLength={performanceOverviewLength}
            setPerformanceOverviewLength={setPerformanceOverviewLength}
            performanceOverviewExpand={performanceOverviewExpand}
            setPerformanceOverviewExpand={setPerformanceOverviewExpand}
            guidingSystemLength={guidingSystemLength}
            setGuidingSystemLength={setGuidingSystemLength}
            guidingSystemExpand={guidingSystemExpand}
            setGuidingSystemExpand={setGuidingSystemExpand}
            mechanics={mechanics}
            productTableHeaders={productTableHeaders}
            technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
            performanceOverviewTableHeaders={performanceOverviewTableHeaders}
            getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
          />
          <AxisSelectionTableHeadersSection
            data-testid="axis-selection-table-headers-section"
            productExpand={productExpand}
            technicalFeatureExpand={technicalFeatureExpand}
            performanceOverviewExpand={performanceOverviewExpand}
            guidingSystemExpand={guidingSystemExpand}
            mechanics={mechanics}
            productTableHeaders={productTableHeaders}
            technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
            performanceOverviewTableHeaders={performanceOverviewTableHeaders}
            getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
          />
        </thead>

        <tbody className="border-b border-solid border-gray-200 " key="tbody">
          {axesCombinations && !isLoadingOrFetching && (
            <AxisSelectionTableRowsSection
              data-testid="axis-selection-table-rows-section"
              products={axesCombinations}
              productLength={productLength}
              technicalFeatureLength={technicalFeatureLength}
              performanceOverviewLength={performanceOverviewLength}
              guidingSystemLength={guidingSystemLength}
              mechanics={mechanics}
              selectedAxis={selectedAxis}
              axesToCompare={axesToCompare}
              axisSelection={axisSelection}
              steps={steps}
              productTableHeaders={productTableHeaders}
              technicalFeaturesTableHeaders={technicalFeaturesTableHeaders}
              performanceOverviewTableHeaders={performanceOverviewTableHeaders}
              getGuidingSystemTableHeaders={getGuidingSystemTableHeaders}
              setCartesianCurrentStep={setCartesianCurrentStep}
              setAxisOptions={setAxisOptions}
              setAxisSelection={setAxisSelection}
              addAxisToCompare={addAxisToCompare}
            />
          )}
        </tbody>
      </table>
      {isLoadingOrFetching && <TableSkeleton />}
      <Pagination
        paging={paging}
        setPaging={setPaging}
        countOfResults={countOfResults}
        showPagination={!isLoadingOrFetching}
        data-testid="pagination"
      />
      {!isLoadingOrFetching && axesCombinations && countOfResults === 0 && (
        <div className="flex justify-center">
          <div className="border-2 border-warningLevelRed w-fit p-1 font-bold mb-3">
            {t("cartesian.ui.axis_selection.zero_results")}
          </div>
        </div>
      )}
    </>
  );
};

export default AxisSelectionTableSection;
